module.exports = __webpack_public_path__ + "img/217-4a1411.png";